import React from 'react'
import PropTypes from 'prop-types'
import SvgIcon from 'Components/SvgIcon'

import {
  frequencyOptions,
} from 'Defaults/inputData'
import {
  _FrequencySelect,
  _Item,
  _FrequencyLabel,
} from './styles'


const FrequencySelect = ({ title, frequencyId, onSelect, blurBackground = true }) => (
  <_FrequencySelect
    title={title}
    titleLeftIconName={'#icon-alert'}
    blurBackground={blurBackground}
    size="large"
  >
    {
      frequencyOptions.map((feq) => {
        // eslint-disable-next-line
        if(feq.value == frequencyId) return null
        return (
          <_Item
            key={feq.value}
            onClick={() => onSelect(feq)}
          >
            <SvgIcon name={'#icon-alert'} width={16} height={16} />
            <_FrequencyLabel>{feq.label}</_FrequencyLabel>
          </_Item>
        )
      })
    }

  </_FrequencySelect>
)

FrequencySelect.propTypes = {
  title: PropTypes.string,
  frequencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onSelect: PropTypes.func,
  blurBackground: PropTypes.bool,
}

export default FrequencySelect
